import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

const links = [["Home", "/"], ["Facilities", "/facilities"], ["Rooms", "/rooms"], ["Contact", "/contact"]];

const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const solidBookingHeader = location.pathname === "/roomtype" || location.pathname === "/booking/checkout";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 45);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [location.pathname]);

  return (
    <motion.header
      initial={{ y: -90 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ${scrolled || solidBookingHeader ? "bg-[#14274A]/95 shadow-[0_8px_30px_rgba(4,13,30,.2)] backdrop-blur-md" : "bg-gradient-to-b from-black/45 to-transparent"}`}
    >
      <div className={`mx-auto flex max-w-[1480px] items-center justify-between px-6 transition-all duration-500 sm:px-10 lg:px-16 ${scrolled || solidBookingHeader ? "h-[78px]" : "h-[96px]"}`}>
        <Link to="/" aria-label="Zeebar Resort home" className="relative z-[2] flex items-center gap-3 text-white">
          <img src="/images/logo/logo.png" alt="Zeebar Resort" className={`object-contain transition-all duration-500 ${scrolled || solidBookingHeader ? "h-16 w-16" : "h-20 w-20"}`} />
        </Link>

        <nav className="hidden items-center gap-10 lg:flex">
          {links.map(([label, path]) => (
            <Link key={path} to={path} className={`nav-link ${location.pathname === path ? "is-active" : ""}`}>{label}</Link>
          ))}
          <button onClick={() => navigate("/booking")} className="border border-[#E0B973] px-5 py-3 font-montserrat text-[10px] font-semibold uppercase tracking-[0.2em] text-white transition-colors hover:bg-[#E0B973] hover:text-[#14274A]">Book now</button>
        </nav>

        <button onClick={() => setOpen(!open)} aria-label="Toggle navigation" aria-expanded={open} className="relative z-[2] h-10 w-10 text-white lg:hidden">
          <span className={`absolute left-2 top-[14px] h-px w-6 bg-current transition-all ${open ? "translate-y-[5px] rotate-45" : ""}`} />
          <span className={`absolute left-2 top-[19px] h-px w-6 bg-current transition-all ${open ? "opacity-0" : ""}`} />
          <span className={`absolute left-2 top-[24px] h-px w-6 bg-current transition-all ${open ? "-translate-y-[5px] -rotate-45" : ""}`} />
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -20 }} className="fixed inset-0 z-[1] flex flex-col items-center justify-center gap-8 bg-[#14274A] text-white lg:hidden">
            {links.map(([label, path], index) => <motion.div key={path} initial={{ opacity: 0, y: 15 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: index * 0.07 }}><Link to={path} className="font-garamond text-4xl">{label}</Link></motion.div>)}
            <button onClick={() => navigate("/booking")} className="gold-button mt-3">Book your stay</button>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};

export default Header;
